import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { ref } from 'vue';
import { StarFilled, StarOutlined } from '@ant-design/icons-vue';
import { RATING_SCORE_MAXIMUM } from '@/model/doujin';


export default /*#__PURE__*/_defineComponent({
  __name: 'RatingStar',
  props: {
    value: {}
  },
  emits: ["rating"],
  setup(__props: any, { emit }) {



const isClicked = ref(false);
const ratingHover = ref(0);


async function rating(score: number) {
	isClicked.value = true;
	await emit('rating', score);
}

function setRatingHover(score: number) {
	if (score !== ratingHover.value) {
		isClicked.value = false;
	}
	ratingHover.value = score;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center gap-2",
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (setRatingHover(0)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(_unref(RATING_SCORE_MAXIMUM)), (_, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "text-yellow-400 cursor-pointer",
        onClick: ($event: any) => (rating(index + 1))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(
					((ratingHover.value === 0 && _ctx.value >= index + 1) || ratingHover.value >= index + 1) &&
					(!isClicked.value || _ctx.value !== 0)
						? _unref(StarFilled)
						: _unref(StarOutlined)
				), {
          style: { fontSize: '20px' },
          onMouseenter: ($event: any) => (setRatingHover(index + 1))
        }, null, 40, ["onMouseenter"]))
      ], 8, _hoisted_1))
    }), 128))
  ], 32))
}
}

})